import{a as r}from"./chunk-2HA4XQFN.js";function a(r){var a=r.children;return a}r(a,"GenericLayout");export{a as a};